export { CommentGutterHandle } from './comment-gutter-handle';
